import { IControl } from '../icontrol';
import { ControlType } from '../../controltype';
import { DisplayType } from './displayType';

/**
 * 帮助控件
 */
export class HelpContol implements IControl {
    /**
     * 默认显示
     */
    placeholder: string;
    /**
     * 帮助数据源
     */
    uri: string;

    /**
     * 帮助的文本显示字段
     */
    textField: string;

    /**
     * 帮助值字段
     */
    valueField: string;

    idField: string;
    helpId: string;
    displayType: DisplayType;

    /**
     * 字段映射信息
     */
    mapFields: any;

    /**
     * 是否是展示在扩展区域内的
     */
    isExtend: boolean;

    /** 是否显示label */
    showLabel: boolean;

    /** 是否必填 */
    required: boolean;

    /**
     * 帮助前事件
     */
    preEventCmd: any;

    title: string;

    /**
     * 帮助后事件
     */
    postEventCmd: any;

    /**
     * 运行时参数配置传递
     */
    context: any;

    /** 启用构造完整树过滤 */
    enableFullTree: boolean;
    /** 树形帮助数据加载方式： default: 内置取数； loadall: 加载所有 layerload：分层加载 */
    loadTreeDataType: 'default' | 'loadall' | 'layerload';
    /** 是否支持多选 */
    singleSelect: boolean;
    /** 展开到指定级数 */
    expandLevel: number;
    /** 是否启用级联选择控制选项 */
    enableCascade: boolean;
    /**
     * 获取控件类型
     */
    getControlType(): ControlType {
        return ControlType.Help;
    }
    /**
  * 值变化时，需要清空哪些字段
  */
    clearFields: string;
    /** 允许编辑 */
    editable?: boolean;
    /** 多字段查询 */
    enableMultiFieldSearch?: boolean;
}
